module.exports = __webpack_public_path__ + "05_medium_brown.c73b9390.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_medium_brown.png
// module id = 0+k1
// module chunks = 0